import { useCallback } from 'react';
import { Item, Picker } from '@adobe/react-spectrum';
import useTheme from "./useTheme.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ThemePicker() {
  var _useTheme = useTheme(),
    selectedThemeKey = _useTheme.selectedThemeKey,
    setSelectedThemeKey = _useTheme.setSelectedThemeKey,
    themes = _useTheme.themes;
  var onSelectionChange = useCallback(key => {
    if (key != null) {
      setSelectedThemeKey("".concat(key));
    }
  }, [setSelectedThemeKey]);
  return /*#__PURE__*/_jsx(Picker, {
    label: "Pick a color scheme",
    items: themes,
    selectedKey: selectedThemeKey,
    onSelectionChange: onSelectionChange,
    children: item => /*#__PURE__*/_jsx(Item, {
      children: item.name
    }, item.themeKey)
  });
}
export default ThemePicker;
//# sourceMappingURL=ThemePicker.js.map